import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {useFavouritesAmplitudeEntities} from "../../../favorite/hooks/use_favourites_amplitude_entities";
import {AmplitudeFavouriteLocation, IAmplitudeFavouritesEventParams} from "../../../favorite/tracking/get_amplitude_favourites_event_properties";
import {trackAmplitudeAddToFavourites} from "../../../favorite/tracking/track_amplitude_add_to_favourites";
import {trackAmplitudeRemoveFromFavourites} from "../../../favorite/tracking/track_amplitude_remove_from_favourites";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

const FAVOURITE_PLACEMENT = "rp_favourite_investment_page";

interface Props {
    offerId: number;
    favouriteLocation: AmplitudeFavouriteLocation;
}

export const ConstructionGalleryPlaceholder = (props: Props) => {
    const {offerId, favouriteLocation} = props;
    const {addOfferToFavourites, removeOfferFromFavourites, isOfferInFavourites, loaded, isTreatmentGuest} = useFavourites();
    const {offer} = useFavouritesAmplitudeEntities({offerId});

    const isInFavourites = isOfferInFavourites(offerId);
    const btnText = isInFavourites ? "Usuń z ulubionych" : "Dodaj do ulubionych";

    const favouritesEventParams: IAmplitudeFavouritesEventParams = {
        location: favouriteLocation,
        favouritePlacement: FAVOURITE_PLACEMENT,
        offer
    };

    const handleClick = async () => {
        if (isInFavourites) {
            const wasRemoved = await removeOfferFromFavourites(offerId);

            if (!wasRemoved) {
                return;
            }

            trackAmplitudeRemoveFromFavourites(favouritesEventParams);
        } else {
            const wasAdded = await addOfferToFavourites(offerId, FAVOURITE_PLACEMENT, favouriteLocation);

            if (!wasAdded || isTreatmentGuest) {
                return;
            }

            trackAmplitudeAddToFavourites(favouritesEventParams);
        }
    };

    return (
        <div className={holder}>
            <div className={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    className={imageStyle}
                />
                <Text variant="headline_3" as="p" color="white" align="center" mb={3}>
                    Zdjęcia z budowy nie są jeszcze dostępne
                </Text>
                <Text variant="body_copy_1" color="white" align="center" mb={3}>
                    {isInFavourites ? "Dodaliśmy" : "Dodaj"} tę ofertę do ulubionych na Twoim koncie {isInFavourites ? "i" : "a"} powiadomimy Cię, gdy zdjęcia
                    się pojawią.
                </Text>
                <Button variant="outlined_secondary_light" onClick={handleClick} className={btnStyle}>
                    {loaded ? btnText : <Loader size="sm" />}
                </Button>
            </div>
        </div>
    );
};

const holder = css({
    p: 2,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    h: "80%",
    overflow: "auto",

    md: {
        justifyContent: "center",
        flexDirection: "row",
        h: "100%"
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "460px"
});

const imageStyle = css({
    mb: 4,
    display: "flex",
    justifyContent: "center"
});

const btnStyle = css({
    maxWidth: "240px",
    mx: "auto"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {useFavouritesAmplitudeEntities} from "../../../favorite/hooks/use_favourites_amplitude_entities";
import {AmplitudeFavouriteLocation, IAmplitudeFavouritesEventParams} from "../../../favorite/tracking/get_amplitude_favourites_event_properties";
import {trackAmplitudeAddToFavourites} from "../../../favorite/tracking/track_amplitude_add_to_favourites";
import {trackAmplitudeRemoveFromFavourites} from "../../../favorite/tracking/track_amplitude_remove_from_favourites";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

const FAVOURITE_PLACEMENT = "rp_favourite_investment_page";

interface Props {
    offerId: number;
    favouriteLocation: AmplitudeFavouriteLocation;
}

export const ConstructionGalleryPlaceholder = (props: Props) => {
    const {offerId, favouriteLocation} = props;
    const {addOfferToFavourites, removeOfferFromFavourites, isOfferInFavourites, loaded, isTreatmentGuest} = useFavourites();
    const {offer} = useFavouritesAmplitudeEntities({offerId});

    const isInFavourites = isOfferInFavourites(offerId);
    const btnText = isInFavourites ? "Usuń z ulubionych" : "Dodaj do ulubionych";

    const favouritesEventParams: IAmplitudeFavouritesEventParams = {
        location: favouriteLocation,
        favouritePlacement: FAVOURITE_PLACEMENT,
        offer
    };

    const handleClick = async () => {
        if (isInFavourites) {
            const wasRemoved = await removeOfferFromFavourites(offerId);

            if (!wasRemoved) {
                return;
            }

            trackAmplitudeRemoveFromFavourites(favouritesEventParams);
        } else {
            const wasAdded = await addOfferToFavourites(offerId, FAVOURITE_PLACEMENT, favouriteLocation);

            if (!wasAdded || isTreatmentGuest) {
                return;
            }

            trackAmplitudeAddToFavourites(favouritesEventParams);
        }
    };

    return (
        <div className={holder}>
            <div className={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    className={imageStyle}
                />
                <Text variant="headline_3" as="p" color="white" align="center" mb={3}>
                    Zdjęcia z budowy nie są jeszcze dostępne
                </Text>
                <Text variant="body_copy_1" color="white" align="center" mb={3}>
                    {isInFavourites ? "Dodaliśmy" : "Dodaj"} tę ofertę do ulubionych na Twoim koncie {isInFavourites ? "i" : "a"} powiadomimy Cię, gdy zdjęcia
                    się pojawią.
                </Text>
                <Button variant="outlined_secondary_light" onClick={handleClick} className={btnStyle}>
                    {loaded ? btnText : <Loader size="sm" />}
                </Button>
            </div>
        </div>
    );
};

const holder = css({
    p: 2,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    h: "80%",
    overflow: "auto",

    md: {
        justifyContent: "center",
        flexDirection: "row",
        h: "100%"
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "460px"
});

const imageStyle = css({
    mb: 4,
    display: "flex",
    justifyContent: "center"
});

const btnStyle = css({
    maxWidth: "240px",
    mx: "auto"
});
